// Central prompt management
export * from './systemPrompts';
export * from './deploymentEmailPrompts';
export * from './codeAssistantPrompts';

// Prompt management utilities
export const getAllPrompts = () => {
  const { SYSTEM_PROMPTS } = require('./systemPrompts');
  const { DEPLOYMENT_EMAIL_TEMPLATES, PRODUCT_DETAILS, LLM_DETAILS, SAAS_DETAILS, TABLE_INSTRUCTIONS } = require('./deploymentEmailPrompts');
  const { CODE_ASSISTANT_PROMPTS, CODE_PATTERNS } = require('./codeAssistantPrompts');
  
  return {
    systemPrompts: SYSTEM_PROMPTS,
    deploymentEmailTemplates: DEPLOYMENT_EMAIL_TEMPLATES,
    productDetails: PRODUCT_DETAILS,
    additionalContext: {
      llmDetails: LLM_DETAILS,
      saasDetails: SAAS_DETAILS,
      tableInstructions: TABLE_INSTRUCTIONS
    },
    codeAssistantPrompts: CODE_ASSISTANT_PROMPTS,
    codePatterns: CODE_PATTERNS
  };
};

// Update a specific prompt
export const updatePrompt = (category, promptKey, newValue) => {
  const prompts = getAllPrompts();
  if (prompts[category] && prompts[category][promptKey]) {
    prompts[category][promptKey] = newValue;
    return true;
  }
  return false;
};

// Get prompt by path (e.g., "systemPrompts.GENERAL")
export const getPromptByPath = (path) => {
  const parts = path.split('.');
  let current = getAllPrompts();
  
  for (const part of parts) {
    if (current && current[part]) {
      current = current[part];
    } else {
      return null;
    }
  }
  
  return current;
};